import animateValues from './animateValues';
$(function () {
  var numberElements = document.querySelectorAll('.NumberCards--valueToCount');
  Array.from(numberElements).forEach(function (el) {
    return el.innerText = 0;
  });

  if (window.IntersectionObserver) {
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // entry.target.classList.remove('is-hidden');
          // entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
          return animateValues({
            a: 0
          }, 2500, {
            a: parseFloat(entry.target.dataset.value),
            onUpdate: function onUpdate(v) {
              return entry.target.innerText = v.a.toFixed(1).replace(/\.0+$/, '');
            },
            ease: function ease(t) {
              return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
            }
          });
        }
      });
    }, {
      rootMargin: '0px 0px -200px 0px'
    });
    numberElements.forEach(function (section) {
      return observer.observe(section);
    });
  }

  $('.NumberCards--slider').flickity({
    cellSelector: '.NumberCards-slide',
    contain: true,
    imagesLoaded: true,
    pageDots: true,
    prevNextButtons: false,
    groupCells: 1,
    wrapAround: true,
    watchCSS: true,
    cellAlign: 'left'
  });
});